module.exports = __webpack_public_path__ + "static/media/dni-tramite.b412b9c2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar/img/dni-tramite.png
 ** module id = 2054
 ** module chunks = 0
 **/